export default __webpack_public_path__ + "static/media/12.0f08bb9a.jpg";